import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import moment from "moment";

"use strict";
ko.bindingHandlers.timer = {
    init: function(elt, va, bindings, model, context) {
        var timer = ko.toJS(va()),
            opts = {"aria-valuemin" : "0", "role" : "progressbar", "extra-class" : "", "progress-class" : "progress-bar-green"};
            if (timer.status == "suspended")
                $.extend(opts, {
                    "extra-class" : "bg-gray",
                    "progress-class" : "bg-dark-gray"
                });
        var duration = timer.scheduled_duration;
        if (duration < 0) {
            duration = timer.time_left + timer.time_passed;
        }
            if (timer.time_left > 0)
                $.extend(opts, {
                    "aria-valuenow" : duration - timer.time_left,
                    "aria-valuemax" : duration
                });
            else
                $.extend(opts, {
                    "aria-valuenow" : duration,
                    "aria-valuemax" : Math.abs(timer.time_left) + duration,
                    "extra-class" : "bg-red"
                });
        $("<div></div>").addClass("progress-bar " + opts["progress-class"]).attr(opts).css({"width":parseInt(opts["aria-valuenow"]/opts["aria-valuemax"]*100, 10)  + "%"}).appendTo($(elt).find(".progress.xs").addClass(opts["extra-class"]));
    }
};

ko.bindingHandlers.timerbox = {
    init: function(elt, va, bindings, model, context) {
        var timer_data = va();
        var new_timer = {
            colour: ko.pureComputed(() => {
                if (ko.unwrap(timer_data.status) == "completed") {
                    return ko.unwrap(timer_data.actual_duration) > ko.unwrap(timer_data.scheduled_duration) ?
                            "danger" : "success";
                } else {
                    var dt = new moment(ko.unwrap(timer_data.deadline_date));

                    return dt.unix() < moment().unix() ?
                            "danger": "success";
                }
            }),
            icon: ko.pureComputed(() => {
                return ko.unwrap(timer_data.icon);
            }),
            caption: ko.pureComputed(() => {
                return ko.unwrap(timer_data.name);
            }),
            deadline_date: ko.pureComputed(() => {
                var dt = dt = ko.unwrap(timer_data.deadline_date);
                return new moment(dt).format("L LT");
            }),
            end_date: ko.pureComputed(() => {
                var dt = dt = ko.unwrap(timer_data.end_date);
                return new moment(dt).format("L LT");
            }),
            main_date: ko.pureComputed(() => {
                var dt = null;
                if (ko.unwrap(timer_data.status) == "completed") {
                    dt = ko.unwrap(timer_data.end_date);
                } else  {
                    dt = ko.unwrap(timer_data.deadline_date);
                }
                return new moment(dt).format("L LT");
            }),
            has_progress: ko.pureComputed(() => {
                if (ko.unwrap(timer_data.status) == "completed") {
                    return false;
                } else {
                    return true;
                }

            }),
            progress: ko.pureComputed(() => {
                var st = new moment(ko.unwrap(timer_data.started_date));
                var due = new moment(ko.unwrap(timer_data.deadline_date));

                var current = (ko.unwrap(timer_data.status) == "completed") ?
                   new moment(ko.unwrap(timer_data.end_date)) :
                   new moment();
                if (current > due || due <= st) {
                    return "100%";
                } else {
                    return parseInt((current.unix() - st.unix()) * 100.0 / (due.unix() - st.unix())) + "%";
                }
            }),
            status_icon: ko.pureComputed(() => {
                return ko.unwrap(timer_data.status) == "completed" ?
                    (new_timer.colour() == "danger" ? "fa-thumbs-o-down" : "fa-thumbs-o-up") :
                    "fa-flag";
            }),
            status: ko.pureComputed(() => {
                return "boh?"
            }),
            duration: ko.pureComputed(() => {
                var scheduled_duration = ko.unwrap(timer_data.scheduled_duration);
                if (ko.unwrap(timer_data.is_in_days)) {
                    if (scheduled_duration != 0) {
                        return _("timer_frontend_duration_days", "{0} days").format(scheduled_duration);
                    }

                } else {
                    if (scheduled_duration != 0) {
                        return "" + parseInt(Math.abs(scheduled_duration) / 60, 10) +":"+ parseInt(Math.abs(scheduled_duration) % 60, 10);
                    }
                }
            }),
            actual_duration: ko.pureComputed(() => {
                var duration = ko.unwrap(timer_data.actual_duration);
                if (duration != 0) {
                    return "" + parseInt(Math.abs(duration) / 60, 10) +":"+ parseInt(Math.abs(duration) % 60, 10);
                }
            }),
            is_completed: ko.pureComputed(() => {
                return ko.unwrap(timer_data.status) == "completed";
            })

        };

        ko.applyBindingsToDescendants(context.createChildContext(new_timer), elt);
        return {"controlsDescendantBindings": true};

    }
}

